var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExternalLink(_vm.to))?_c('a',{attrs:{"href":_vm.to,"rel":"noopener noreferrer"}},[_vm._t("default")],2):_c('nuxt-link',{attrs:{"to":_vm.localePath(_vm.to)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }